import React from 'react'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {DivWithHint} from '@components/common/hint/hint'
import {TwLabel, TwLabelContainer} from './containers'

interface Props {
  label: string
  onClick?: (e: React.MouseEvent) => void
}

export const PinnedLabel = ({label, onClick}: Props) => (
  <TwLabelContainer content={label} onClick={onClick}>
    <DivWithHint content={Lang.msg.messagePinEditHint} className="flex-none">
      <Icon
        icon="IconPinned"
        size={16}
        color="secondary"
        className="group-hover/label:text-action-default"
      />
    </DivWithHint>
    <TwLabel>{label}</TwLabel>
  </TwLabelContainer>
)
